import http from '@/utils/http';
const base_path = '/v2/campaign';

/**
 * 获取广告列表接口
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const getCampaignListApi = (params) => {
  return http.get({
    url: base_path,
    params,
  });
};

/**
 * 获取广告列表选择器接口
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const getCampaignSelectorApi = (params) => {
  return http.get({
    url: `${base_path}/list`,
    params,
  });
};

/**
 * 同步广告列表接口
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const pullCampaignListApi = (params) => {
  return http.get({
    url: `${base_path}/pull`,
    params,
  });
};

/**
 * 同步广告状态接口
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const pullCampaignStatusApi = (params) => {
  return http.get({
    url: `${base_path}/pullStatus`,
    params,
  });
};

/**
 * 获取广告详情接口
 * @param {string} id 广告id
 * @param {Object} params 接口请求参数
 * @returns {Promise<Object>}
 */
export const getCampaignDetailApi = (id, params) => {
  return http.get({
    url: `${base_path}/${id}`,
    params,
  });
};

/**
 * 更新广告接口
 * @param {string} id 广告id
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const editCampaignApi = (id, data) => {
  return http.put({
    url: `${base_path}/${id}`,
    data,
  });
};

/**
 * 更新广告状态接口
 * @param {string} id 广告id
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const updateCampaignStatusApi = (id, data) => {
  return http.put({
    url: `${base_path}/updateStatus/${id}`,
    data,
  });
};

/**
 * 删除广告
 * @param {Object} data 接口请求参数
 * @returns {Promise<Object>}
 */
export const deteleCampaignApi = (data) => {
  return http.delete({
    url: `${base_path}/delete`,
    data,
  });
};
